// extracted by mini-css-extract-plugin
export default {"posts-filter":"PostFilter_posts-filter__Qp-OK","clickbutton":"PostFilter_clickbutton__8O5B8","button":"PostFilter_button__IHSxI"};